/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaymentStateShare Input Action
 */
export class CheckoutButtonStateShareInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `checkout-button-state-share`;
    public getCacheObjectType = () => 'checkout-button-state-share';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface ICheckoutButtonStateShareData {
    isEnable: boolean;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CheckoutButtonStateShareInput();
};

async function action(input: CheckoutButtonStateShareInput, ctx: Msdyn365.IActionContext): Promise<ICheckoutButtonStateShareData> {
    return { isEnable: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckoutButtonStateShareData>>action,
    id: 'CheckoutButtonStateShare',
    input: createInput
});
